import angular from "angular";
import component from "./trains-control.component";

angular.module('trainsControl', [component]);

export default 'trainsControl';


// WEBPACK FOOTER //
// ./resources/assets/modules/trains-control/trains-control.module.js